export const unitDefinitions = {
  area: [
    { key: 'sqmm', name: 'Quadratmillimeter (mm²)', factor: 0.000001 },
    { key: 'sqcm', name: 'Quadratzentimeter (cm²)', factor: 0.0001 },
    { key: 'sqm', name: 'Quadratmeter (m²)', factor: 1 },
    { key: 'sqkm', name: 'Quadratkilometer (km²)', factor: 1000000 },
    { key: 'hectare', name: 'Hektar (ha)', factor: 10000 },
    { key: 'are', name: 'Ar (a)', factor: 100 },
    { key: 'sqft', name: 'Quadratfuß (ft²)', factor: 0.092903 },
    { key: 'sqyd', name: 'Quadratyard (yd²)', factor: 0.836127 },
    { key: 'acre', name: 'Acre', factor: 4046.86 }
  ],
  
  data: [
    { key: 'byte', name: 'Byte (B)', factor: 1 },
    { key: 'kb', name: 'Kilobyte (KB)', factor: 1000 },
    { key: 'mb', name: 'Megabyte (MB)', factor: 1000000 },
    { key: 'gb', name: 'Gigabyte (GB)', factor: 1000000000 },
    { key: 'tb', name: 'Terabyte (TB)', factor: 1000000000000 },
    { key: 'pb', name: 'Petabyte (PB)', factor: 1000000000000000 }
  ],
  
  length: [
    { key: 'mm', name: 'Millimeter (mm)', factor: 0.001 },
    { key: 'cm', name: 'Zentimeter (cm)', factor: 0.01 },
    { key: 'm', name: 'Meter (m)', factor: 1 },
    { key: 'km', name: 'Kilometer (km)', factor: 1000 },
    { key: 'inch', name: 'Zoll (in)', factor: 0.0254 },
    { key: 'ft', name: 'Fuß (ft)', factor: 0.3048 },
    { key: 'yd', name: 'Yard (yd)', factor: 0.9144 },
    { key: 'mile', name: 'Meile (mi)', factor: 1609.34 }
  ],
  
  speed: [
    { key: 'ms', name: 'Meter pro Sekunde (m/s)', factor: 1 },
    { key: 'kmh', name: 'Kilometer pro Stunde (km/h)', factor: 0.277778 },
    { key: 'mph', name: 'Meilen pro Stunde (mph)', factor: 0.44704 },
    { key: 'knot', name: 'Knoten (kn)', factor: 0.514444 },
    { key: 'fts', name: 'Fuß pro Sekunde (ft/s)', factor: 0.3048 }
  ],
  
  time: [
    { key: 'ms', name: 'Millisekunde (ms)', factor: 0.001 },
    { key: 's', name: 'Sekunde (s)', factor: 1 },
    { key: 'min', name: 'Minute (min)', factor: 60 },
    { key: 'h', name: 'Stunde (h)', factor: 3600 },
    { key: 'day', name: 'Tag', factor: 86400 },
    { key: 'week', name: 'Woche', factor: 604800 },
    { key: 'month', name: 'Monat (30 Tage)', factor: 2592000 },
    { key: 'year', name: 'Jahr (365 Tage)', factor: 31536000 }
  ],
  
  volume: [
    { key: 'ml', name: 'Milliliter (ml)', factor: 0.001 },
    { key: 'cl', name: 'Zentiliter (cl)', factor: 0.01 },
    { key: 'dl', name: 'Deziliter (dl)', factor: 0.1 },
    { key: 'l', name: 'Liter (l)', factor: 1 },
    { key: 'm3', name: 'Kubikmeter (m³)', factor: 1000 },
    { key: 'galus', name: 'US-Gallone (gal)', factor: 3.78541 },
    { key: 'cupus', name: 'US-Cup', factor: 0.236588 },
    { key: 'flozus', name: 'US-Flüssigunze (fl oz)', factor: 0.0295735 }
  ],
  
  weight: [
    { key: 'mg', name: 'Milligramm (mg)', factor: 0.000001 },
    { key: 'g', name: 'Gramm (g)', factor: 0.001 },
    { key: 'kg', name: 'Kilogramm (kg)', factor: 1 },
    { key: 't', name: 'Tonne (t)', factor: 1000 },
    { key: 'oz', name: 'Unze (oz)', factor: 0.0283495 },
    { key: 'lb', name: 'Pfund (lb)', factor: 0.453592 },
    { key: 'stone', name: 'Stone', factor: 6.35029 }
  ]
};